import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { AuthDataProvider } from 'src/components/authProvider';
import { AuthClassification } from 'src/hooks/auth/auth.interface';
import type { IAsset } from 'src/interfaces';
import { queryKeys, requestCCApi } from 'src/utils';

import { mapAllAssets } from './helper';

export const useGetAllAssets = (
  overrideQuerySetting?: UseQueryOptions<IAsset[]>,
) => {
  const { userRole } = useContext(AuthDataProvider);

  return useQuery({
    queryKey: queryKeys.assets.all(),
    queryFn: fetchAllAssets,
    enabled: userRole !== AuthClassification.OWNER_OPERATOR,
    staleTime: Infinity,
    ...overrideQuerySetting,
  });
};

export const fetchAllAssets = async () => {
  const url = `/hqAssets?pageSize=0`;

  const response = await requestCCApi({ url });

  if (response.data) {
    return mapAllAssets(response.data);
  }

  return [];
};
